export const DOCTOR_ALL = 'all';
export const DOCTOR_ADD = 'add';
export const DOCTOR_DELETE = 'delete';
export const DOCTOR_SINGLE = 'single';
export const DOCTOR_RESET = 'reset';
